module.exports = __webpack_public_path__ + "fonts/c87e3b2.ttf";